import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import {
  UpdateCartBuyerIdentityDocument,
  type UpdateCartBuyerIdentityMutation,
} from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { GQLBuyerIdentityInput, mapGQLCartToCart } from './graphql'

export const buyerIdentityUpdate =
  (options: GlobalRequestOptions) =>
  async (cartId: string, buyerIdentity: GQLBuyerIdentityInput): Promise<Cart> => {
    const response = await storefrontClient.request<UpdateCartBuyerIdentityMutation>(
      print(UpdateCartBuyerIdentityDocument),
      {
        variables: {
          cartId,
          buyerIdentity,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartBuyerIdentityUpdate

    if (!payload?.cart) {
      throw new Error('Failed to update buyer identity')
    }

    return mapGQLCartToCart(payload.cart)
  }
